import * as React from "react";
import { withRouter } from 'react-router'
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";
import NavigateParent from "./navigateParent";
import ReactIframeResizer from "../common/iFrameResizerComponent";

class ResetTest extends React.Component {

    constructor(props) {
        super(props);
        
    }

    render() {
        
        const iframeResizerOptions = { checkOrigin: false, minHeight: 1400, scrolling: true, heightCalculationMethod: 'bodyScroll' };
        const iframeResizerStyle = { width: '100%' };
        const noLinks = { minHeight: '1400px', height: '100%' };
        return (
            <div style={noLinks} className="mychartDataTile">
                <ReactIframeResizer id={"mycharttest"} title="Reset" iframeResizerOptions={iframeResizerOptions} src={"/reset"} style={iframeResizerStyle} />
            </div>);
    }
}


export default ResetTest;